import { ArrowRight, MessageCircle, Phone, MapPin, Clock } from "lucide-react";
import { whatsappUrl, WHATSAPP_NUMBER } from "./constants";

export const FinalCTA = () => {
  const phoneDisplay = `+39 ${WHATSAPP_NUMBER.slice(2, 5)} ${WHATSAPP_NUMBER.slice(5, 8)} ${WHATSAPP_NUMBER.slice(8)}`;

  return (
    <section
      id="contatti"
      data-testid="final-cta-section"
      className="relative bg-[#0E1A14] text-white py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 dot-grid opacity-20" />
      <div className="absolute -top-32 -right-32 w-[400px] h-[400px] rounded-full bg-[#1F6E45] blur-[120px] opacity-30" />

      <div className="relative max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.22em] text-[#7BD9A1] font-bold mb-5">
              · Inizia ora
            </div>
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-7xl tracking-tight leading-[0.98]">
              Trasforma il fisico.
              <br />
              <span className="text-[#7BD9A1]">Rivoluziona la mente.</span>
            </h2>
            <p className="mt-7 max-w-xl text-white/70 text-base md:text-lg leading-relaxed">
              Una chiacchierata di 15 minuti su WhatsApp per capire se il
              metodo Sacco fa per te. Nessun impegno: solo una conversazione
              tra te e me.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-whatsapp-cta"
                className="group inline-flex items-center gap-2.5 bg-[#7BD9A1] text-[#0E1A14] px-7 py-4 rounded-full font-bold text-sm hover:bg-white transition-all active:scale-95"
              >
                <MessageCircle size={17} strokeWidth={2.4} />
                Scrivimi su WhatsApp
                <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={`tel:+${WHATSAPP_NUMBER}`}
                data-testid="phone-cta"
                className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/20 text-white text-sm font-semibold hover:border-[#7BD9A1] hover:text-[#7BD9A1] transition-colors"
              >
                <Phone size={15} strokeWidth={2} />
                {phoneDisplay}
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-7 md:p-8">
              <div className="text-xs uppercase tracking-[0.22em] text-[#7BD9A1] font-bold mb-5">
                · Studio
              </div>
              <ul className="space-y-5">
                <Info icon={MapPin} label="Studio" value="Viale Quintino Sella 35/C, 36100 Vicenza" />
                <li className="flex items-start gap-4">
                  <div className="w-9 h-9 grid place-items-center rounded-lg border border-white/15 bg-white/5 flex-shrink-0">
                    <Clock size={16} strokeWidth={1.8} className="text-[#7BD9A1]" />
                  </div>
                  <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.22em] text-white/50 font-bold mb-2">
                      Orari
                    </div>
                    <ul className="space-y-1 text-sm text-white">
                      {[
                        ["Lun", "14:30 – 20:00"],
                        ["Mar", "11:00 – 20:00"],
                        ["Mer", "Chiuso"],
                        ["Gio", "08:00 – 20:00"],
                        ["Ven", "Chiuso"],
                        ["Sab", "08:00 – 14:00"],
                        ["Dom", "Chiuso"],
                      ].map(([d, h]) => (
                        <li key={d} className="flex justify-between gap-4 border-b border-white/5 pb-1 last:border-0">
                          <span className="text-white/50 w-12">{d}</span>
                          <span className={h === "Chiuso" ? "text-white/40" : "text-white"}>{h}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                <Info icon={MessageCircle} label="Risposta" value="Entro 48h, sempre" />
              </ul>
              <div className="mt-7 pt-6 border-t border-white/10 grid grid-cols-3 gap-3">
                {[
                  { v: "1:1", l: "Coaching" },
                  { v: "350+", l: "Pazienti" },
                  { v: "5.0★", l: "Google" },
                ].map((s) => (
                  <div key={s.l} className="text-center p-3 bg-white/5 rounded-xl border border-white/10">
                    <div className="font-display text-lg text-[#7BD9A1]">{s.v}</div>
                    <div className="text-[10px] uppercase tracking-[0.18em] text-white/50 mt-1 font-semibold">
                      {s.l}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Info = ({ icon: Icon, label, value }) => (
  <li className="flex items-start gap-4">
    <div className="w-9 h-9 grid place-items-center rounded-lg border border-white/15 bg-white/5 flex-shrink-0">
      <Icon size={16} strokeWidth={1.8} className="text-[#7BD9A1]" />
    </div>
    <div>
      <div className="text-[10px] uppercase tracking-[0.22em] text-white/50 font-bold">
        {label}
      </div>
      <div className="text-white text-sm md:text-base mt-1">{value}</div>
    </div>
  </li>
);
